if (!customElements.get('vto-modal')) {
  customElements.define(
    'vto-modal',
    class VtoModal extends FetchModalDialog {
      constructor() {
        super();
        this.vto = {
          state : {
            apiKey : this.getAttribute('data-api-key'),
            versionID : this.getAttribute('data-version-id'),
            experienceType : this.getAttribute('data-vto-type'),
            previousBarcode: null,
            ymkAsyncInitialized: false,
            variantBarcodes: this.getAttribute('data-variant-barcodes')
          },
          // wizard set up for bundles
          wizard: {
            isWizard: this.getAttribute('data-is-wizard') === 'true',
            handles: this.getAttribute('data-wizard-handles') ? this.getAttribute('data-wizard-handles').split(',').map(h => h.trim()) : [],
            allBundleHandles: this.getAttribute('data-all-bundle-handles') ? this.getAttribute('data-all-bundle-handles').split(',').map(h => h.trim()) : [],
            currentIndex: 0,
            selectedShades: {},
            badgesInitialized: false,
            isReloadingCamera: false,
            hasReloadedCamera: false
          },
          components : {
            modalContent: this.querySelector('.vto-modal__content'),
            getStartedButton : this.querySelector('.vto-modal__get-started-button'),
            modalBackButton : this.querySelector('.vto-modal__back'),
            modalToggleButton : this.querySelector('.vto-modal__toggle'),
            allExperiences: this.querySelector('.vto-modal__all-experiences'),
            basicExperience : this.querySelector('.vto-modal__basic-experience'),
            smartExperience: this.querySelector('.vto-modal__smart-experience'),
            review: this.querySelector('.vto-modal__review'),
            legal : this.querySelector('.vto-modal__legal'),
            legalCheckBox: this.querySelector('#Vto-legal-checkbox'),
            swatches: this.querySelectorAll('.vto-modal__swatch'),
            circleSwatches: this.querySelectorAll('.vto-modal__circle-swatch'),
            removeButton: this.querySelectorAll('.vto-modal__remove-style'),
            vtoBackButton: this.querySelector('button[aria-label="go back to launcher screen"]'),
            vtoAddToBagButton: this.querySelector('.vto-modal__content #vto_modal_add_form .cta-button'),
            vtoAddToBagFormInput: this.querySelector('#vto_modal_add_form input.product-variant-id[name="id"]'),
            shadeName: this.querySelector('.vto-select-a-shade'),
            shadeInputs: this.querySelectorAll('input.vto-shade-input[type="radio"]'),
            allShadesButton: this.querySelector('#display-all-shades'),
            wizardPrevButton: this.querySelector('[data-wizard-prev]'),
            wizardNextButton: this.querySelector('[data-wizard-next]'),
            wizardFinishButton: this.querySelector('[data-wizard-finish]'),
            wizardProductImages: this.querySelectorAll('.vto-wizard__product-image'),
            productTitle: this.querySelector('.vto-product-title'),
            swatchContainer: this.querySelector('.vto-modal__basic-experience .swiper-wrapper')
          },
          openFromModalDialog : null,
          openFromFindaton : null,
          openerProductId : this.getAttribute('data-opener-product-id'),
          masterId: this.getAttribute('data-masterid'),
          fromBundle : this.getAttribute('data-from-bundle') === 'true' ? true : false,

        }
      }

      connectedCallback() {
        this.initEventListeners();
        this.appendYouCamScript();
        this.initSwatchSwiper();
        this.waitForWindowProperty('YMK').then(lib => {
          this.initYouCamWindow();
        })
        .catch(err => {
          console.error(err);
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        if (opener) {
          super.show(opener);
          if (opener.tagName && opener.tagName.toUpperCase() === "FINDATION-WIDGET") {
            this.openFromFindation = opener;
          } else {
            this.openFromModalDialog = opener.closest('modal-dialog') || opener.closest('fetch-modal-dialog');
          }
        }
        if (this.openFromModalDialog || this.openFromFindation) {
          this.vto.components.modalBackButton.classList.remove('hidden');
        } else {
          this.vto.components.modalBackButton.classList.add('hidden');
        }

        // Initialize bundle wizard product image badges on first show
        if (this.vto.wizard.isWizard && !this.vto.wizard.badgesInitialized) {
          this.initializeWizardBadges();
          this.loadWizardProductAtCurrentIndex();
          this.vto.wizard.badgesInitialized = true;
        }
      }

      handleBackButtonClick() {
        if (this.openFromModalDialog) {
          this.hide();
          this.openFromModalDialog.show();
        }
        if (this.openFromFindation) {
          this.hide();
          this.openFromFindation.openWidget();
        }
      }

      handleGetStartClick() {
        this.vto.components.modalToggleButton.classList.add('hidden');
        this.vto.components.legal.classList.add('hidden');
        this.vto.components.allExperiences.classList.remove('hidden');
        this.toggleVtoExperience(this.vto.state.experienceType);
        if (this.vto.state.experienceType === 'Smart') {
          this.openShadeFinder();
        } else {
          window.YMK.open();
        }
      }

      updateAddToBagButton() {
        if (this.vto.components.vtoAddToBagButton) {
            let selectedProduct = this.vto.components.vtoAddToBagButton.getAttribute('data-selected-variant-id');
            let selectedProductAvailability = this.vto.components.vtoAddToBagButton.getAttribute('data-selected-variant-available');
            let disableATBButton = true;
            if (selectedProduct && selectedProductAvailability == 'true') {
                disableATBButton = false;
            }
            this.vto.components.vtoAddToBagButton.disabled = disableATBButton;
        }
      }

      handleSwatchClick(e) {
        const closestSwatch = e.target.closest('.vto-modal__swatch');
        if (closestSwatch) {
          // no selection swatch click events for bundle wizard setup
          const isNoSelection = closestSwatch.hasAttribute('data-no-selection');
          if (isNoSelection && this.vto.wizard.isWizard) {
            this.vto.components.swatches.forEach(btn => btn.classList.remove('vto-swatch-selected'));
            closestSwatch.classList.add('vto-swatch-selected');
            const defaultName = this.vto.components.shadeName.getAttribute('data-default-name');
            this.vto.components.shadeName.textContent = defaultName || 'Select a shade';
            delete this.vto.wizard.selectedShades[this.vto.wizard.currentIndex];
            this.resetCurrentBadgeToNoSelection();
            this.updateWizardButtonVisibility();
            this.reapplyWizardMakeup();
            return;
          }

          const barcode = closestSwatch.dataset.variantBarcode;
          const variantID = closestSwatch.dataset.variantId;
          const variantTitle = closestSwatch.dataset.variantTitle;
          const swatchImg = closestSwatch.dataset.variantSwatchImg;

          // update selected shade name
          this.vto.components.shadeName.textContent = variantTitle;
          // add selected ID to atb button
          this.vto.components.vtoAddToBagButton.setAttribute('data-selected-variant-id', variantID);
          // add selected variant availability to atb button
          if (closestSwatch.classList.contains('oos')) {
            this.vto.components.vtoAddToBagButton.setAttribute('data-selected-variant-available', false);
          } else {
            this.vto.components.vtoAddToBagButton.setAttribute('data-selected-variant-available', true);
          }
          // remove selected class
          this.vto.components.swatches.forEach(btn => btn.classList.remove('vto-swatch-selected'));
          // add selected class
          closestSwatch.classList.add('vto-swatch-selected');

          // Check the radio input for the clicked swatch
          const radioInput = closestSwatch.querySelector('input[type="radio"]');
          if (radioInput) {
            radioInput.checked = true;
          }

          // If this is a smart experience swatch, also check the corresponding basic experience swatch
          if (closestSwatch.classList.contains('smart-result-swatch')) {
            const basicSwatch = this.querySelector(`.vto-modal__swatch[data-variant-barcode="${barcode}"]:not(.smart-result-swatch)`);
            if (basicSwatch) {
              basicSwatch.classList.add('vto-swatch-selected');
              const basicRadioInput = basicSwatch.querySelector('input[type="radio"]');
              if (basicRadioInput) {
                basicRadioInput.checked = true;
              }
            }
          }

          // If wizard mode, save selection and update badge
          if (this.vto.wizard.isWizard) {
            this.vto.wizard.selectedShades[this.vto.wizard.currentIndex] = {
              variantTitle: variantTitle,
              swatchImg: swatchImg,
              variantID: variantID,
              barcode: barcode
            };
            this.updateWizardBadge(this.vto.wizard.currentIndex, swatchImg, variantTitle);
            // Enable Next/Finish button now that a selection is made
            this.updateWizardButtonVisibility();
          }
          if (this.vto.state.previousBarcode !== barcode) {
            window.YMK.applyMakeupBySku(barcode);
            this.vto.state.previousBarcode = barcode;
               // only for smart experience, update shade-match local storage
               if(closestSwatch.classList.contains('smart-result-swatch') && barcode && this.dataset.handle) {
                const data = {
                  handle: this.dataset.handle,
                  barcode: barcode,
                  featureID: 'vto'
                };
                document.body.dispatchEvent(new CustomEvent('shadeMatch:setData', { detail : data }));
              }
          } else {
            window.YMK.applyMakeupBySku(barcode);
          }

          if (this.vto.fromBundle) {
            // handle the possible vto modal on bundle pdp/qv when only 1 product is vto
            // find opener swatch, use the vto modal opener product id for main product id
            const variantSelects = this.querySelectorAll(`variant-selects[data-picker-type="bundle-picker"][data-product-id="${this.vto.masterId}"]`); 
            if (variantSelects.length) {
              variantSelects.forEach(variantSelect => {
                variantSelect.querySelector(`input[data-variant-id="${variantID}"`)?.click();
              });
            }
          } else {
            // update add to bag form with variant ID
            this.vto.components.vtoAddToBagFormInput.value = variantID;
          }
        }
        this.updateAddToBagButton();
      }

      handleAddToBagClick() {
        window.YMK.close();
        const findMyShadeModal = document.querySelector('#findMyShadeModal');
        findMyShadeModal.hide();
      }

      handleDisplayAllShades() {
        this.toggleVtoExperience();
      }

      handleRemoveButtonClick() {
        this.vto.components.swatches.forEach(btn => btn.classList.remove('vto-swatch-selected'));
        this.vto.components.circleSwatches.forEach(btn => btn.classList.remove('checked'));
        this.vto.components.vtoAddToBagButton.removeAttribute('data-selected-variant-available');
        this.vto.components.vtoAddToBagButton.removeAttribute('data-selected-variant-id');
        this.vto.components.vtoAddToBagButton.disabled = true;
        this.vto.components.shadeName.textContent = ' ';
        this.vto.components.shadeInputs.forEach((input) => {
          input.checked = false;
        });
        window.YMK.reset();

        // If wizard mode, delete saved selection and update badge/button
        if (this.vto.wizard.isWizard) {
          delete this.vto.wizard.selectedShades[this.vto.wizard.currentIndex];
          this.resetCurrentBadgeToNoSelection();
          this.updateWizardButtonVisibility();
        }
      }

      resetSwatches() {
        this.vto.components.swatches.forEach(btn => btn.classList.remove('vto-swatch-selected'));
        this.vto.components.shadeInputs.forEach((input) => {
          input.checked = false;
        });
        this.vto.components.shadeName.textContent = this.vto.components.shadeName.dataset.defaultname;
      }

      handleYouCamCloseEvent() {
        // Don't close modal if we're intentionally reloading camera for wizard navigation
        if (this.vto.wizard.isWizard && this.vto.wizard.isReloadingCamera) {
          return;
        }

        this.vto.components.legalCheckBox.checked = false;
        this.vto.components.getStartedButton.disabled = false;
        this.resetSwatches();
        this.hide();
        removeTrapFocus();
      }

      handleShadeFinderCompleteEvent(result) {
        const filteredIDs = this.filterIDs(result.recommendations);
      
        if (filteredIDs) {
          const entries = ['warmer', 'cooler', 'lighter', 'darker', 'matched'];
      
          entries.forEach(key => {
            const entry = filteredIDs[key];
            const smartSwatchContainer = this.querySelector(`.smart-experience-suggestions .${key}`);
            if (!entry || !entry.skuId) {
              smartSwatchContainer.classList.add('hidden');
            } else {
              const vtoSwatch = this.querySelector(`.vto-modal__swatch[data-variant-barcode="${entry.skuId}"]:not(smart-result-swatch)`);
              const vtoSwatchInput = vtoSwatch?.querySelector('input');
              if (vtoSwatch && vtoSwatchInput && vtoSwatch.dataset.variantSwatchImg) {
                smartSwatchContainer.classList.remove('hidden');
                const isOos = vtoSwatch.classList.contains('oos');
                const smartSwatch = smartSwatchContainer.querySelector('.vto-modal__swatch');
                const smartSwatchInput = smartSwatch.querySelector('input');
                const smartSwatchImg = smartSwatch.querySelector('img');
                
                smartSwatch.setAttribute('data-variant-title', vtoSwatch.dataset.variantTitle);
                smartSwatch.setAttribute('data-variant-barcode', vtoSwatch.dataset.variantBarcode);
                smartSwatch.setAttribute('data-variant-id', vtoSwatch.dataset.variantId);
                smartSwatch.setAttribute('data-variant-swatch-img', vtoSwatch.dataset.variantSwatchImg);
                smartSwatchInput.name = 'smart-' + vtoSwatchInput.name;
                smartSwatchInput.value = vtoSwatchInput.value;
                smartSwatchImg.alt = vtoSwatch.dataset.variantTitle;
                smartSwatchImg.title = vtoSwatch.dataset.variantTitle;
                smartSwatchImg.src = vtoSwatch.dataset.variantSwatchImg;

                if (isOos) {
                  smartSwatch.classList.add('oos');
                  smartSwatchInput.disabled = true;
                }

                // // update shade-match local storage with inital match
                if (key === 'matched') {
                  const data = {
                    handle: this.dataset.handle,
                    barcode: vtoSwatch.dataset.variantBarcode,
                    featureID: 'vto'
                  };
                  document.body.dispatchEvent(new CustomEvent('shadeMatch:setData', { detail : data }));
                  vtoSwatch.click();
                }
              } else {
                smartSwatchContainer.classList.add('hidden');
              }
            }
          });

          if (document.querySelector('.smart-experience-suggestions .matched .swatch').getAttribute('data-variant-id').length > 0) {
            document.querySelector('.smart-experience-suggestions .matched .swatch').click();
          }
          this.toggleVtoExperience('Smart');
        }
      }
      

      filterIDs(results) {
        let result = null;
        if (results) {
          let deltaE = 10;
          let variantIDs = this.vto.state.variantBarcodes;
          if (variantIDs.length > 0) {
            for (var j = 0; j < results.length; j++) {
                if (typeof results[j].guid.skuId !== 'undefined' && variantIDs.includes(results[j].guid.skuId) && results[j].delta_e < deltaE) {
                    result = results[j];
                    deltaE = results[j].delta_e;
                }
            }
          }
        }
        return result;
      }

      handleCameraFailedEvent() {
        this.toggleVtoExperience('Basic');
      }

      handleUIDisplay() {
        const vtoUI = this.querySelector('.vto-modal__all-experiences-inner-wrapper');
        vtoUI?.classList.remove('ghost');
      }

      initEventListeners() {
        this.vto.components.legalCheckBox.addEventListener('change', () => {  this.vto.components.getStartedButton.disabled = !this.vto.components.legalCheckBox.checked; });
        this.vto.components.getStartedButton.addEventListener( 'click', this.handleGetStartClick.bind(this));
        this.vto.components.modalBackButton.addEventListener('click', this.handleBackButtonClick.bind(this));
        this.vto.components.swatches.forEach(swatch => { swatch.addEventListener('click', this.handleSwatchClick.bind(this)) });
        this.vto.components.removeButton.forEach(button => {button.addEventListener('click', this.handleRemoveButtonClick.bind(this))});
        this.vto.components.vtoAddToBagButton.disabled = true;
        this.vto.components.vtoAddToBagButton.addEventListener('click', this.handleAddToBagClick.bind(this));
        this.vto.components.allShadesButton.addEventListener('click', this.handleDisplayAllShades.bind(this));

        // Bundle wizard product navigation
        if (this.vto.wizard.isWizard) {
          if (this.vto.components.wizardPrevButton) {
            this.vto.components.wizardPrevButton.addEventListener('click', this.handleWizardPrev.bind(this));
          }
          if (this.vto.components.wizardNextButton) {
            this.vto.components.wizardNextButton.addEventListener('click', this.handleWizardNext.bind(this));
          }
          if (this.vto.components.wizardFinishButton) {
            this.vto.components.wizardFinishButton.addEventListener('click', this.handleWizardFinish.bind(this));
          }

          // Review experience navigation
          const reviewBackButton = this.querySelector('[data-review-back]');
          if (reviewBackButton) {
            reviewBackButton.addEventListener('click', this.handleReviewBack.bind(this));
          }

          const reviewCloseButton = this.querySelector('[data-review-close]');
          if (reviewCloseButton) {
            reviewCloseButton.addEventListener('click', this.handleReviewClose.bind(this));
          }

          // Intercept form submission for wizard bundles
          const productForms = this.querySelectorAll('product-form');
          productForms.forEach(productForm => {
            const form = productForm.querySelector('form');
            if (form) {
              form.addEventListener('submit', this.handleBundleWizardFormSubmit.bind(this), true);
            }
          });
        }
      }

      // bundle add to bag
      async handleBundleWizardFormSubmit(evt) {
        // Only intercept for wizard mode
        if (!this.vto.wizard.isWizard) return;

        evt.preventDefault();
        evt.stopPropagation();

        // Get bundle metadata from hidden inputs or data attributes
        const bundleProductId = this.querySelector('input[name="bundle_product_id"]')?.value || this.getAttribute('data-opener-product-id');
        const bundleProductName = this.querySelector('input[name="bundle_product_name"]')?.value;
        const bundleSku = this.querySelector('input[name="bundle_sku"]')?.value;
        const bundleHandle = this.querySelector('input[name="bundle_handle"]')?.value;
        const bundleShade = this.querySelector('input[name="bundle_shade"]')?.value;
        const bundleSize = this.querySelector('input[name="bundle_size"]')?.value;
        const bundleImage = this.querySelector('input[name="bundle_image"]')?.value;

        // Get the submit button and cart elements
        const submitButton = evt.target.querySelector('[type="submit"]');
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (submitButton) {
          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
        }

        // Fetch bundle prices if not already cached
        if (!window.bundlePrices && bundleProductId && window.fetchBundlePrices) {
          try {
            window.bundlePrices = await window.fetchBundlePrices(bundleProductId);
            if (!window.bundlePrices || Object.keys(window.bundlePrices).length === 0) {
              throw new Error('Failed to retrieve bundle pricing');
            }
          } catch (error) {
            console.error('Bundle pricing error:', error);
            alert('Something went wrong. Please try reloading and adding to cart again.');
            if (submitButton) {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('aria-disabled');
            }
            return;
          }
        }

        // Create unique bundle key
        const bundleKey = `bundle_${new Date().getTime()}`;

        // Get parent variant ID (first available variant from the bundle parent product)
        const parentVariantId = this.querySelector('.product-variant-id')?.value;

        // Get promo flags if available
        const promoFlags = window.getPromoLineItemProperties ?
          window.getPromoLineItemProperties(
            ['.product-section product-info[data-view-context="PDP"]', 'product-info[data-view-context="Quickview"]'],
            { mode: 'flags' }
          ) : {};

        // Build the bundle items from ALL bundle products
        const items = [];
        const allHandles = this.vto.wizard.allBundleHandles.length > 0 ? this.vto.wizard.allBundleHandles : this.vto.wizard.handles;

        allHandles.forEach((handle, bundleIndex) => {
          const productData = window.wizardProductData?.[handle];

          // Find if this product has a selection in the wizard
          const wizardIndex = this.vto.wizard.handles.indexOf(handle);
          const selection = wizardIndex !== -1 ? this.vto.wizard.selectedShades[wizardIndex] : null;

          let variantId = null;

          if (selection && selection.variantID) {
            // Product with shade selection from wizard
            variantId = selection.variantID;
          } else if (productData && productData.variants && productData.variants.length > 0) {
            // Product without shade selection - use first available variant
            variantId = productData.variants[0].id;
          }

          if (variantId) {
            const props = {
              '_bundle_key': bundleKey,
              '_parent_id': parentVariantId,
              '_bundle_sku': bundleSku,
              '_bundle_name': bundleProductName,
              '_bundle_image': bundleImage,
              '_bundle_product_id': bundleProductId,
              '_bundle_handle': bundleHandle,
              '_bundle_shade': bundleShade,
              '_bundle_size': bundleSize,
              ...promoFlags
            };

            // Add bundle pricing if available
            if (window.bundlePrices) {
              props['_bundle_price'] = JSON.stringify(window.bundlePrices);
            }

            items.push({
              id: variantId,
              quantity: 1,
              properties: props
            });
          }
        });

        if (items.length === 0) {
          console.error('No items selected in wizard');
          if (submitButton) {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          }
          return;
        }

        const productInfoContainer = this.vto.components.review.querySelector('.vto-review__product-metafields-data');
        const variantIdNumber = Number(parentVariantId);
        const shouldBlock = await window.preventAddIfMaxedOut(variantIdNumber, productInfoContainer);
        if (shouldBlock) {
          window.YMK.close();

          if (submitButton) {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          }
          return;
        }

        // Add items to cart
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: items,
            sections: cart ? cart.getSectionsToRender().map(section => section.id) : []
          })
        })
          .then(response => response.json())
          .then(response => {
            if (response.status) {
              console.error('Cart add error:', response);
              alert(response.description || 'Error adding to cart');
            } else {
              // Success - update cart UI
              if (cart && response.sections) {
                cart.renderContents(response);
              }

              // Close the modal
              window.YMK.close();
              const findMyShadeModal = document.querySelector('#findMyShadeModal');
              if (findMyShadeModal) {
                findMyShadeModal.hide();
              }
            }
          })
          .catch(error => {
            console.error('Cart add error:', error);
            alert('Error adding to cart');
          })
          .finally(() => {
            if (submitButton) {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('aria-disabled');
            }
          });
      }

      initYouCamWindow() {
        const _this = this;
        const windowWidth = window.innerWidth < window.screen.width ? window.innerWidth : window.screen.width;
        const ymkModuleWidth = windowWidth < 480 ? windowWidth : 375;
        const ymkSettings = {
          width: ymkModuleWidth,
          height: ymkModuleWidth, // square
          shadeFinderResultVersion: 'v2',
          shadeFinderDeltaEThreshold: 100,
          userConsent: 'agree'
        };

        window.ymkAsyncInit = (function () {
            window.YMK.init(ymkSettings);
            _this.vto.state.ymkAsyncInitialized = true;

            // set ymk event listeners
            // window.YMK.addEventListener('opened', function () {
            //   handleOpenEvent();
            // });
            window.YMK.addEventListener('closed', function () {
              _this.handleYouCamCloseEvent();
            });
            window.YMK.addEventListener('shadeFinderComplete', function (result) {
              _this.handleShadeFinderCompleteEvent(result);
            });
            window.YMK.addEventListener('cameraFailed', function () {
              _this.handleCameraFailedEvent();
            });
            window.YMK.addEventListener('loaded', function () {
              // handleLoadedEvent();
              _this.handleUIDisplay();
            });
            window.YMK.addEventListener('engineClosed', function () {
              // handleEngineClosedEvent();
              const vtoUI = _this.querySelector('.vto-modal__all-experiences-inner-wrapper');
              vtoUI?.classList.add('ghost');
            });
        }());
      }

      // TODO: possibly add code here to account opening, reopening, switching back and forth between basic and smart
      openShadeFinder() {
        window.YMK.openShadeFinder();
        // start by displaying the Basic swatches until handleShadeFinderCompleteEvent() renders the results
        this.toggleVtoExperience('Basic');
      }

      initSwatchSwiper() {
        const vtoShadeCarousel = this.querySelector('.vto-modal__swatch-swiper');
        if (!window.reduceShadeSelection) {
          window.reduceShadeSelection = { reduceShades: false };
        }
        (async () => {
          try {
            const vtoExperience = document.querySelector('.vto-modal__content')
            const reducedTarget =
              vtoExperience?.querySelector('[data-reduced-shades]')?.getAttribute('data-reduced-shades')
                ?.toLowerCase() || '';
            const shouldReduceShades = await window.shouldRemoveSlides(reducedTarget);
            window.reduceShadeSelection = { reduceShades : !!shouldReduceShades };
          } catch (e) {
            window.reduceShadeSelection = { reduceShades: false };
          }
        })();

        if (window.reduceShadeSelection.reduceShades) {
          const nonReducedShades = vtoShadeCarousel.querySelectorAll('.swiper-wrapper .vto-modal__swatch[data-include-reduced="false"]');
          nonReducedShades.forEach(shade => shade.remove())
        }

        const slideSelector = window.reduceShadeSelection.reduceShades
          ? '.swiper-wrapper .vto-modal__swatch[data-include-reduced="true"]'
          : '.swiper-wrapper .vto-modal__swatch';

        const slides = vtoShadeCarousel?.querySelectorAll(slideSelector);
        const vtoSwiperSwatchesCount = slides.length;


        if (vtoSwiperSwatchesCount > 6) {
          this.querySelector('.vto-modal__swiper-button-prev')?.classList.remove('hidden');
          this.querySelector('.vto-modal__swiper-button-next')?.classList.remove('hidden');
        }

        new Swiper('.vto-modal__swatch-swiper', {
          slidesPerView: 6,
          slidesPerGroup: 6,
          spaceBetween: 12,
          centerInsufficientSlides: true,
          allowTouchMove: true,
          loop: false,
          navigation: {
              nextEl: '.vto-modal__swiper-button-next',
              prevEl: '.vto-modal__swiper-button-prev'
          },
          breakpoints: {
            736: {
                slidesPerView: 6,
                slidesPerGroup: 6,
                spaceBetween: 12,
            }
          }
        });
      }

      appendYouCamScript() {
        if (typeof (YMK) === 'undefined') {
          (function (d,v,k) {
            var s = d.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://plugins-media.makeupar.com/' + v + '/sdk.js?apiKey=' + k;
            var x = d.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
          })(document, this.vto.state.versionID, this.vto.state.apiKey);
        }
      }

      toggleVtoExperience(experienceType) {
        switch (experienceType) {
          // TODO ADA call trapFocus from sites/tarte/assets/global.js on the opened experience
          case 'Basic' : 
            this.vto.components.basicExperience.classList.remove('hidden');
            this.vto.components.smartExperience.classList.add('hidden');
            trapFocus(this.vto.components.modalContent);
            break;
          case 'Smart' :
            this.vto.components.basicExperience.classList.add('hidden');
            this.vto.components.smartExperience.classList.remove('hidden');
            trapFocus(this.vto.components.modalContent, this.vto.components.modalContent);
            this.handleUIDisplay();
            break;
          default:
            // Basic
            this.vto.components.basicExperience.classList.remove('hidden');
            this.vto.components.smartExperience.classList.add('hidden');
            trapFocus(this.vto.components.modalContent);
        }
      }

      // ========================================
      // Bundle wizard experience
      // ========================================
      initializeWizardBadges() {
        // Initialize all product badges to show "no selection" state
        this.vto.components.wizardProductImages.forEach((productImage, index) => {
          const badge = productImage.querySelector('.vto-wizard__shade-badge');
          if (badge) {
            // Show badge with no-selection class
            badge.classList.add('no-selection');
            badge.style.display = 'block';
          }
        });
      }

      updateWizardBadge(productIndex, swatchImgUrl, variantTitle) {
        const productImage = this.vto.components.wizardProductImages[productIndex];
        if (productImage) {
          const badge = productImage.querySelector('.vto-wizard__shade-badge');
          if (badge && swatchImgUrl) {
            badge.classList.remove('no-selection');
            badge.style.backgroundImage = `url(${swatchImgUrl})`;
            badge.style.display = 'block';
            productImage.classList.add('has-selection');
          }
        }
      }

      reapplyWizardMakeup() {
        // Reset YMK first
        window.YMK.reset();
        this.vto.state.previousBarcode = null;

        // Re-apply all saved products except the current one
        Object.keys(this.vto.wizard.selectedShades).forEach(index => {
          const parsedIndex = parseInt(index);
          if (parsedIndex !== this.vto.wizard.currentIndex) {
            const shade = this.vto.wizard.selectedShades[parsedIndex];
            if (shade && shade.barcode) {
              window.YMK.applyMakeupBySku(shade.barcode);
            }
          }
        });
      }

      updateWizardButtonVisibility() {
        const currentIndex = this.vto.wizard.currentIndex;
        const totalProducts = this.vto.wizard.handles.length;
        const hasSelection = !!this.vto.wizard.selectedShades[currentIndex];

        if (totalProducts === 1) {
          // Single product bundle: hide Previous, hide Next, show Finish
          this.vto.components.wizardPrevButton?.classList.add('hidden');
          this.vto.components.wizardNextButton?.classList.add('hidden');
          this.vto.components.wizardFinishButton?.classList.remove('hidden');
          // Disable Finish if no selection
          if (this.vto.components.wizardFinishButton) {
            this.vto.components.wizardFinishButton.disabled = !hasSelection;
          }
        } else if (currentIndex === 0) {
          // First product: hide Previous, show Next, hide Finish
          this.vto.components.wizardPrevButton?.classList.add('hidden');
          this.vto.components.wizardNextButton?.classList.remove('hidden');
          this.vto.components.wizardFinishButton?.classList.add('hidden');
          // Disable Next if no selection
          if (this.vto.components.wizardNextButton) {
            this.vto.components.wizardNextButton.disabled = !hasSelection;
          }
        } else if (currentIndex === totalProducts - 1) {
          // Last product: show Previous, hide Next, show Finish
          this.vto.components.wizardPrevButton?.classList.remove('hidden');
          this.vto.components.wizardNextButton?.classList.add('hidden');
          this.vto.components.wizardFinishButton?.classList.remove('hidden');
          // Disable Finish if no selection
          if (this.vto.components.wizardFinishButton) {
            this.vto.components.wizardFinishButton.disabled = !hasSelection;
          }
        } else {
          // Middle products: show Previous, show Next, hide Finish
          this.vto.components.wizardPrevButton?.classList.remove('hidden');
          this.vto.components.wizardNextButton?.classList.remove('hidden');
          this.vto.components.wizardFinishButton?.classList.add('hidden');
          // Disable Next if no selection
          if (this.vto.components.wizardNextButton) {
            this.vto.components.wizardNextButton.disabled = !hasSelection;
          }
        }
      }

      loadWizardProductAtCurrentIndex() {
        const handle = this.vto.wizard.handles[this.vto.wizard.currentIndex];
        if (window.wizardProductData && window.wizardProductData[handle]) {
          this.updateWizardProduct(window.wizardProductData[handle]);
          this.updateWizardButtonVisibility();
        } else {
          console.error('No pre-loaded data found for handle:', handle);
        }
      }

      resetCurrentBadgeToNoSelection() {
        const productImage = this.vto.components.wizardProductImages[this.vto.wizard.currentIndex];
        if (productImage) {
          const badge = productImage.querySelector('.vto-wizard__shade-badge');
          if (badge) {
            badge.classList.add('no-selection');
            badge.style.backgroundImage = '';
            productImage.classList.remove('has-selection');
          }
        }
      }

      handleWizardPrev(e) {
        e?.preventDefault();
        e?.stopPropagation();

        if (this.vto.wizard.currentIndex > 0) {
          this.vto.wizard.currentIndex--;
          this.loadWizardProductAtCurrentIndex();
        }
      }

      handleWizardNext(e) {
        e?.preventDefault();
        e?.stopPropagation();

        if (this.vto.wizard.currentIndex < this.vto.wizard.handles.length - 1) {
          this.vto.wizard.currentIndex++;
          this.loadWizardProductAtCurrentIndex();
        }
      }

      handleWizardFinish(e) {
        e?.preventDefault();
        e?.stopPropagation();

        // Show review experience and populate it with selections
        this.showReviewExperience();
      }

      handleReviewBack(e) {
        e?.preventDefault();
        e?.stopPropagation();

        // Hide review and show all experiences
        if (this.vto.components.review) {
          this.vto.components.review.classList.add('hidden');
        }
        if (this.vto.components.allExperiences) {
          this.vto.components.allExperiences.classList.remove('hidden');
        }
        if (this.vto.components.modalToggleButton) {
          this.vto.components.modalToggleButton.classList.remove('hidden');
        }

        // Reset to last product
        this.vto.wizard.currentIndex = this.vto.wizard.handles.length - 1;
        this.loadWizardProductAtCurrentIndex();
      }

      handleReviewClose(e) {
        e?.preventDefault();
        e?.stopPropagation();

        // Close YMK and hide the modal
        window.YMK.close();
      }

      showReviewExperience() {
        // Hide legal and all experiences
        if (this.vto.components.legal) {
          this.vto.components.legal.classList.add('hidden');
        }
        if (this.vto.components.allExperiences) {
          this.vto.components.allExperiences.classList.add('hidden');
        }
        if (this.vto.components.modalToggleButton) {
          this.vto.components.modalToggleButton.classList.add('hidden');
        }

        // Show review only
        if (this.vto.components.review) {
          this.vto.components.review.classList.remove('hidden');
        }

        // Update add to bag button text for bundle review
        const reviewAddButton = this.vto.components.review?.querySelector('.cta-button .cta-content');
        if (reviewAddButton) {
          reviewAddButton.textContent = 'ADD BUNDLE TO BAG';
        }

        // Populate review with all bundle products and their selections
        const reviewProducts = this.querySelectorAll('.vto-review__product-item');

        reviewProducts.forEach(productItem => {
          const handle = productItem.getAttribute('data-product-handle');
          const shadePlaceholder = productItem.querySelector('[data-shade-placeholder]');

          if (shadePlaceholder) {
            // Find if this product has a VTO/shade match selection
            const productIndex = this.vto.wizard.handles.indexOf(handle);

            if (productIndex !== -1 && this.vto.wizard.selectedShades[productIndex]) {
              // This product was in the wizard and has a selection
              const shade = this.vto.wizard.selectedShades[productIndex];

              // Clear placeholder and create swatch display
              shadePlaceholder.innerHTML = '';

              // Create swatch image
              const swatchImg = document.createElement('img');
              swatchImg.src = shade.swatchImg;
              swatchImg.alt = shade.variantTitle;
              swatchImg.className = 'vto-review__swatch-image';

              // Create shade name text
              const shadeText = document.createElement('span');
              shadeText.textContent = shade.variantTitle;
              shadeText.className = 'vto-review__shade-text';

              shadePlaceholder.appendChild(swatchImg);
              shadePlaceholder.appendChild(shadeText);
            } else if (productIndex !== -1) {
              // This product was in the wizard but no shade was selected
              shadePlaceholder.textContent = 'No shade selected';
              shadePlaceholder.style.color = 'var(--grayscale-400)';
            } else {
              // This product was not part of the wizard (no VTO/shade match)
              shadePlaceholder.textContent = 'One size';
              shadePlaceholder.style.fontStyle = 'italic';
            }
          }
        });
      }

      updateWizardProduct(productData) {
        // Only reload camera when moving from product 0 to product 1, product 0 has shade match,
        // and we haven't already done the initial reload
        const firstHandle = this.vto.wizard.handles[0];
        const firstProductData = window.wizardProductData?.[firstHandle];
        const shouldReloadCamera = this.vto.wizard.currentIndex === 1 &&
                                   firstProductData?.hasShadeMatch === true &&
                                   !this.vto.wizard.hasReloadedCamera;

        if (shouldReloadCamera) {
          this.vto.wizard.hasReloadedCamera = true;
          this.vto.wizard.isReloadingCamera = true;
          try {
            const handleCameraReopened = () => {
              this.vto.wizard.isReloadingCamera = false;
              window.YMK.removeEventListener('opened', handleCameraReopened);
            };
            window.YMK.addEventListener('opened', handleCameraReopened);
            const videoElement = document.querySelector('#YMK-module video');
            if (videoElement && videoElement.srcObject) {
              const stream = videoElement.srcObject;
              const tracks = stream.getTracks();
              tracks.forEach(track => track.stop());
              requestAnimationFrame(() => {
                if (window.YMK && window.YMK.open) {
                  window.YMK.open(true);
                }
              });
            } else {
              this.vto.wizard.isReloadingCamera = false;
              window.YMK.removeEventListener('opened', handleCameraReopened);
            }
          } catch (e) {
            this.vto.wizard.isReloadingCamera = false;
          }
        }

        // Reset to basic experience (hide smart experience if it was showing)
        if (this.vto.components.smartExperience && this.vto.components.basicExperience) {
          this.vto.components.smartExperience.classList.add('hidden');
          this.vto.components.basicExperience.classList.remove('hidden');
        }

        // Update active product image
        this.vto.components.wizardProductImages.forEach((img, idx) => {
          if (idx === this.vto.wizard.currentIndex) {
            img.classList.add('active');
          } else {
            img.classList.remove('active');
          }
        });

        // Reset shade name to default (will be updated if saved selection exists)
        if (this.vto.components.shadeName) {
          const defaultName = this.vto.components.shadeName.getAttribute('data-default-name');
          this.vto.components.shadeName.textContent = defaultName || 'Select a shade';
        }

        // Update modal data attributes for YMK
        this.setAttribute('data-masterid', productData.id);
        this.setAttribute('data-handle', productData.handle);
        this.setAttribute('data-vto-type', productData.vtoType || 'Basic');

        // Update barcodes
        const barcodes = productData.variants
          .filter(v => v.available)
          .map(v => v.barcode)
          .filter(b => b);
        this.setAttribute('data-variant-barcodes', `[${barcodes.join(',')}]`);

        // Update vto state
        this.vto.masterId = productData.id;
        this.vto.state.experienceType = productData.vtoType || 'Basic';

        // Update title
        if (this.vto.components.productTitle) {
          this.vto.components.productTitle.textContent = productData.title;
        }

        // Clear and update swatches
        if (this.vto.components.swatchContainer) {
          this.vto.components.swatchContainer.innerHTML = '';

          const availableVariants = productData.variants.filter(v => v.available);

          // Add "no selection" swatch for wizard mode only
          if (this.vto.wizard.isWizard) {
            const noSelectionDiv = document.createElement('div');
            noSelectionDiv.className = 'vto-modal__swatch swatch swiper-slide vto-modal__remove-style';
            noSelectionDiv.setAttribute('data-no-selection', 'true');
            const circleSwatchDiv = document.createElement('div');
            circleSwatchDiv.className = 'vto-modal__circle-swatch circle-swatch';
            const input = document.createElement('input');
            input.type = 'radio';
            input.id = 'vto-modal__swiper-swatch-no-selection';
            input.name = 'vto-swiper-swatch';
            input.value = 'no-selection';
            input.className = 'vto-shade-input';
            const label = document.createElement('label');
            label.setAttribute('for', 'vto-modal__swiper-swatch-no-selection');
            circleSwatchDiv.appendChild(input);
            circleSwatchDiv.appendChild(label);
            noSelectionDiv.appendChild(circleSwatchDiv);
            this.vto.components.swatchContainer.appendChild(noSelectionDiv);
          }

          availableVariants.forEach((variant, index) => {
            const swatchDiv = document.createElement('div');
            swatchDiv.className = 'vto-modal__swatch swatch swiper-slide shade-variant';
            swatchDiv.setAttribute('data-variant-title', variant.title);
            swatchDiv.setAttribute('data-variant-barcode', variant.barcode || '');
            swatchDiv.setAttribute('data-variant-id', variant.id);

            // Use pre-loaded swatch image thumbnail for the data attribute
            if (variant.swatchImgThumb) {
              swatchDiv.setAttribute('data-variant-swatch-img', variant.swatchImgThumb);
            }

            // Create the inner HTML structure with proper attributes
            const circleSwatchDiv = document.createElement('div');
            circleSwatchDiv.className = 'vto-modal__circle-swatch circle-swatch';

            const input = document.createElement('input');
            input.type = 'radio';
            input.id = `vto-modal__swiper-swatch-${index}`;
            input.name = 'vto-swiper-swatch';
            input.value = variant.options || variant.title;
            input.className = 'vto-shade-input';

            const label = document.createElement('label');
            label.setAttribute('for', `vto-modal__swiper-swatch-${index}`);

            const img = document.createElement('img');
            // Use full swatch image for the img src
            img.src = variant.swatchImg || '';
            // Use variant.options for alt and title (like reference code)
            img.alt = variant.options || variant.title;
            img.title = variant.options || variant.title;

            label.appendChild(img);
            circleSwatchDiv.appendChild(input);
            circleSwatchDiv.appendChild(label);
            swatchDiv.appendChild(circleSwatchDiv);

            this.vto.components.swatchContainer.appendChild(swatchDiv);
          });

          // Re-add event listeners to new swatches
          const newSwatches = this.vto.components.swatchContainer.querySelectorAll('.vto-modal__swatch');
          newSwatches.forEach(swatch => {
            swatch.addEventListener('click', this.handleSwatchClick.bind(this));
          });

          // Update component references
          this.vto.components.swatches = this.querySelectorAll('.vto-modal__swatch');

          // Restore saved selection if it exists for this product
          if (this.vto.wizard.selectedShades[this.vto.wizard.currentIndex]) {
            const savedShade = this.vto.wizard.selectedShades[this.vto.wizard.currentIndex];

            // Update shade name
            if (this.vto.components.shadeName) {
              this.vto.components.shadeName.textContent = savedShade.variantTitle;
            }

            // Find and select the matching swatch
            const matchingSwatch = this.vto.components.swatchContainer.querySelector(
              `[data-variant-swatch-img="${savedShade.swatchImg}"]`
            );
            if (matchingSwatch) {
              // Remove selected class from all swatches
              this.vto.components.swatches.forEach(btn => btn.classList.remove('vto-swatch-selected'));
              // Add selected class to saved swatch
              matchingSwatch.classList.add('vto-swatch-selected');

              // Check the radio input
              const radioInput = matchingSwatch.querySelector('input[type="radio"]');
              if (radioInput) {
                radioInput.checked = true;
              }
            }

            // Update badge to show saved selection
            this.updateWizardBadge(this.vto.wizard.currentIndex, savedShade.swatchImg, savedShade.variantTitle);
          }
        }
      }

      // ========================================
      // End bundle wizard experience
      // ========================================

      waitForWindowProperty(prop, timeout = 10000) {
        return new Promise((resolve, reject) => {
          const interval = 50;
          let elapsed = 0;

          const check = () => {
            if (window[prop]) {
              resolve(window[prop]);
            } else if (elapsed >= timeout) {
              reject(new Error(`window.${prop} not found within ${timeout}ms`));
            } else {
              elapsed += interval;
              setTimeout(check, interval);
            }
          };

          check();
        });
      }
    }
  );
}
